import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_ad8bjvlw5g: FaireBrandEntity = {
  token: "b_ad8bjvlw5g",
  type: "brand",
  name: "Untamed Naturals",
  avatarUrl:
    "https://cdn.faire.com/fastly/d59fb01de1353405c33372de941e46a59d802b783bac1d372526e6ee51b1dc09.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/7a07b1a11936e90d2d1483a49af10d2492e9a4535e5f52275c98cbe12a305a01.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d59fb01de1353405c33372de941e46a59d802b783bac1d372526e6ee51b1dc09.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/7a07b1a11936e90d2d1483a49af10d2492e9a4535e5f52275c98cbe12a305a01.jpeg",
  location: "Fontana, CA, USA",
  minimumOrderDollars: 69,
  rating: 4.8,
  reviewCount: 106,
  isTopShop: true,
  isInsider: true,
  description:
    "Untamed Naturals is a family inspired brand with a story behind every product. A newborn baby and an ill husband led us to clean up our home and create good-for-you products like the Calendula Balm for my kid's eczema, the Magnesium Cream for mom's sciatica and so much more. \n\nWe're here to offer family inspired, natural, personal care essentials. From toddlers to grandma, we go your family's needs covered.\n\nUntamed Naturals is 100% plant based, eco conscious and certified cruelty free. We are also community driven and strive to give back in the form of product sponsorships and monetary donations whenever we can. Some of the causes we love and support are The Jackie Robinson Foundation, Habitat for Humanity and Su Casa, a local domestic violence shelter. \n\nOur hope is that our products become daily staples in your home like they are in ours! Thank you!",
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:52:11.332Z",
    importedBy: "entity-db-cli",
  },
};
